var Handlebars = require("handlebars/dist/handlebars.runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "    <div class=\"row\">\r\n        <div class=\"col-xs-12\">\r\n            <div class=\"latest-winner-accordion-title-container\">\r\n                <div class=\"latest-winner-image-container\">\r\n                    <img class=\"img-responsive\" src=\""
    + alias2(alias1((depth0 != null ? depth0.ImageUrl : depth0), depth0))
    + "\">\r\n                </div>\r\n                <div class=\"latest-winner-info-container\">\r\n                    <h4 class=\"title\">"
    + alias2(alias1((depth0 != null ? depth0.Title : depth0), depth0))
    + "</h4>\r\n                    <p class=\"additional-info\">\r\n                        <small>"
    + alias2(alias1((depth0 != null ? depth0.PublicationDateFormatted : depth0), depth0))
    + " &mdash; </small>\r\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.HasPrize : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                        <small>"
    + alias2(alias1((depth0 != null ? depth0.Location : depth0), depth0))
    + "</small>\r\n                    </p>\r\n                </div>\r\n                <span class=\"expand-collapse-sign\"></span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "                            <small>"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.PrizeFormatted : depth0), depth0))
    + " &mdash; </small>\r\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.blockHelperMissing.call(depth0,container.lambda(depth0, depth0),{"name":"this","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./features/latest-winners/latest-winners-accordion-title.handlebars
// module id = 179
// module chunks = 0